<script>
import {
  saveAgreementConsent,
  hasAnyAgreementConsent,
  getAgreementDocs,
  getAgreementVersion,
} from '@/utils/agreement';
import { DEFAULT_LOCALE } from '@/utils/locale';

export default {
  name: 'AgreementConsent',
  data() {
    return {
      checked: false,
      submitting: false,
      docs: [],
      agreementVersion: '',
      isUpdateNotice: false,
      agreementPreviewVisible: false,
      currentAgreement: null,
    };
  },
  created() {
    this.isUpdateNotice = hasAnyAgreementConsent(this.currentUser);
    this.loadAgreementData();
  },
  computed: {
    currentUser() {
      try {
        const raw = localStorage.getItem('user');
        return raw ? JSON.parse(raw) : null;
      } catch (error) {
        return null;
      }
    },
  },
  methods: {
    loadAgreementData() {
      const locale = (this.$i18n && this.$i18n.locale) || DEFAULT_LOCALE;
      Promise.all([getAgreementDocs(locale), getAgreementVersion()]).then(([docs, version]) => {
        this.docs = docs;
        this.agreementVersion = version;
      });
    },
    submitConsent() {
      if (!this.checked) {
        this.$message.warning('请先勾选并同意全部协议');
        return;
      }

      this.submitting = true;
      saveAgreementConsent(this.currentUser, this.agreementVersion);

      const redirectPath = this.$route.query.redirectFrom || '/';
      this.$router.replace(redirectPath).finally(() => {
        this.submitting = false;
      });
    },
    openAgreement(doc) {
      this.currentAgreement = doc;
      this.agreementPreviewVisible = true;
    },
  },
};
</script>

<template>
  <div class="agreement-consent-page">
    <div class="agreement-card">
      <h3 class="title">协议确认</h3>
      <p class="desc" v-if="isUpdateNotice">
        协议内容已更新，请重新阅读并确认同意后继续使用系统。
      </p>
      <p class="desc" v-else>
        为保障您的权益，请先阅读并同意以下协议。
      </p>

      <ul class="agreement-list">
        <li v-for="doc in docs" :key="doc.key">
          <a href="#" @click.prevent="openAgreement(doc)">{{ doc.title }}</a>
        </li>
      </ul>

      <el-checkbox v-model="checked" class="check-line">
        我已阅读并同意上述全部协议
      </el-checkbox>

      <el-button
        type="primary"
        :loading="submitting"
        :disabled="submitting"
        @click="submitConsent"
      >
        确认并继续
      </el-button>
    </div>
    <el-dialog
      :visible.sync="agreementPreviewVisible"
      :title="currentAgreement ? currentAgreement.title : '协议预览'"
      width="80%"
      top="5vh"
      append-to-body
    >
      <iframe
        v-if="currentAgreement && currentAgreement.file"
        :src="currentAgreement.file"
        style="width: 100%; height: 70vh; border: none;"
      />
    </el-dialog>
  </div>
</template>

<style scoped>
.agreement-consent-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f4f6fa;
  padding: 24px;
}

.agreement-card {
  width: 100%;
  max-width: 680px;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.title {
  margin-bottom: 12px;
}

.desc {
  color: #606266;
}

.agreement-list {
  margin: 16px 0;
  padding-left: 18px;
}

.agreement-list li {
  margin-bottom: 10px;
}

.check-line {
  margin-bottom: 18px;
}
</style>
